module.exports = __webpack_public_path__ + "static/media/menino-estressado.dec5b412.jpg";